import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconGpsOffComponent } from "./med-icon-gps-off.component";

@NgModule({
  declarations: [
    MedIconGpsOffComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconGpsOffComponent,
  ],
})
export class MedIconGpsOffModule { }
